module.exports = __webpack_public_path__ + "img/ring_y_o_null_null@3x.3cae9f40.png";